<template>
  <div>
    <span v-for="item in list" :key="item.value" @click="changeType(item)">
      <van-button v-if="item.select" :disabled="item.disabled" type="info" size="small" :color="GetColorMain()">{{ item.text.length>30?item.text.substr(0,40)+"..": item.text }}</van-button>
      <van-button v-if="!item.select" :disabled="item.disabled" plain type="default" :color="GetColorMain()" size="small">{{ item.text.length>30?item.text.substr(0,40)+"..": item.text }}</van-button>
    </span>
  </div>
</template>
<script>
import { Button } from 'vant'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button
  },
  props: {
    // eslint-disable-next-line
    typelist:undefined,
    // eslint-disable-next-line
    value:undefined
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    typelist(newValue, oldValue) {
      this.list = newValue
      this.notice()
    },
    value(newValue) {
      console.log('我监听到了变化', newValue)
      if (this.list.length > 0) {
        this.changeType(newValue)
      }
    }
  },
  created() {
    this.list = this.typelist
    this.notice()
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    notice() {
      this.list.map((item) => {
        if (item.select) {
          this.$emit('input', item)
        }
      })
    },
    changeType(Selectvalue) {
      this.list.forEach(item => {
        if (item.value === Selectvalue.value) {
          if (item.select) {
            // item.select = undefined
            // this.$emit('input', undefined)
          } else {
            item.select = true
            this.$emit('input', Selectvalue)
          }
        } else {
          item.select = undefined
        }
      })
      this.list = JSON.parse(JSON.stringify(this.list))
      this.$emit('onChange')
    }
  }
}
</script>
<style scoped>
button{
  margin: 0.25em 0.5em 0.25em 0;
}
</style>
